import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AnimatedNumber from './animated-number.js';
import { cn } from '../../utils/classnames.js';
const SMALL_FONT_SIZE_BREAKPOINT = 20;
const SYMBOL = '$'; // Only USD is supported for now.
const SEPARATOR_LENGTH = 1;
const FRACTION_DIGITS_LENGTH = 2;
const formatter = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: FRACTION_DIGITS_LENGTH,
    maximumFractionDigits: FRACTION_DIGITS_LENGTH,
});
function formatValue(value) {
    if (value === null) {
        return {
            symbol: SYMBOL,
            integerDigits: '-',
            fractionDigits: `.${'-'.repeat(FRACTION_DIGITS_LENGTH)}`,
        };
    }
    const formattedValue = formatter.format(value);
    const [integerDigits, fractionDigits] = [
        formattedValue.slice(0, -FRACTION_DIGITS_LENGTH - SEPARATOR_LENGTH),
        formattedValue.slice(-FRACTION_DIGITS_LENGTH - SEPARATOR_LENGTH),
    ];
    return { symbol: SYMBOL, integerDigits, fractionDigits };
}
function FancyAmount({ value, className, fontSize = 52 }) {
    const { symbol, integerDigits, fractionDigits } = formatValue(value);
    const small = fontSize <= SMALL_FONT_SIZE_BREAKPOINT;
    // Smaller fonts don't change as drastically.
    const smallerFontSize = Math.round(fontSize * (small ? 0.75 : 0.6));
    return (_jsxs("h1", { className: cn('ui-truncate ui-align-baseline ui-font-medium ui-leading-none ui-text-black theme-dark:ui-text-white', className), style: { fontSize }, children: [_jsx("span", { className: cn(small ? 'ui-mr-0.5' : 'ui-mr-1'), style: { fontSize: small ? fontSize : smallerFontSize }, children: symbol }), _jsx("span", { className: "ui-inline-block", children: _jsx(AnimatedNumber, { amount: integerDigits }) }), _jsx("span", { className: "ui-inline-block ui-text-gray-400 theme-dark:ui-text-neutral-200", style: { fontSize: smallerFontSize }, children: _jsx(AnimatedNumber, { amount: fractionDigits, small: true }) })] }));
}
export default FancyAmount;
